import { createContext } from "react";

const auditTrailContext = createContext({
    // dateRange: [],
    // setDateRange: () => {},
    // search: {},
    // setSearch: () => {},
    apiCall: () => {}
})

export default auditTrailContext